import { deleteCheckDepositAsync } from '../../../../../API/order/escrow/EscrowAPI';
import { createAsyncSlice } from '../../../../createAsyncSlice';

export const { slice: deleteCheckDepositSlice, asyncAction: deleteCheckDepositAction } = createAsyncSlice(
  'deleteCheckDepositSlice',
  deleteCheckDepositAsync
);
